import { Component } from '@angular/core';

@Component({
  selector: 'app-input-preview-playground',
  templateUrl: './input-preview-playground.component.html',
  styleUrls: ['./input-preview-playground.component.scss'],
})
export class InputPreviewPlaygroundComponent {
  value = 'Juan Pérez';
  label = 'Nombre';
  showLabel = true;
  showLeadingIcon = true;
  leadingIcon = 'person';
  showEditIcon = true;
  lastEvent = '';

  onEdit(): void {
    this.lastEvent = `edit @ ${new Date().toLocaleTimeString()}`;
  }
}
